import comp from "./RubricTableWithComment";
export default comp;
